interface IVariablesInputs {
  inputId: string;
  inputText: string;
  links: {
    name: string;
    url: string;
  }[];
  isExtraction: boolean;
  typeOCR?: string | null;
}

interface IVariablesOutputs {
  outputId: string;
  text: string;
}

export interface PublishedFormState {
  variablesInputs: IVariablesInputs[];
  variablesOutputs: IVariablesOutputs[];
}

export enum ActionTypes {
  CREATE_VARIABLES_INPUTS = 'CREATE_VARIABLES_INPUTS',
  CREATE_VARIABLES_OUTPUTS = 'CREATE_VARIABLES_OUTPUTS',
  CLEAR_VARIABLES_INPUTS = 'CLEAR_VARIABLES_INPUTS',
  CLEAR_VARIABLES_OUTPUTS = 'CLEAR_VARIABLES_OUTPUTS',
  UPDATE_INPUT_TEXT = 'UPDATE_INPUT_TEXT',
  UPDATE_INPUT_LINKS = 'UPDATE_INPUT_LINKS',
  UPDATE_OUTPUTS = 'UPDATE_OUTPUTS',
}

export type IActionType =
  | {
      type: ActionTypes.CREATE_VARIABLES_INPUTS;
      payload: { variableInput: IVariablesInputs };
    }
  | {
      type: ActionTypes.CREATE_VARIABLES_OUTPUTS;
      payload: { variableOutput: IVariablesOutputs };
    }
  | {
      type: ActionTypes.CLEAR_VARIABLES_INPUTS;
    }
  | {
      type: ActionTypes.CLEAR_VARIABLES_OUTPUTS;
    }
  | {
      type: ActionTypes.UPDATE_INPUT_TEXT;
      payload: { inputId: string; inputText: string };
    }
  | {
      type: ActionTypes.UPDATE_INPUT_LINKS;
      payload: { inputId: string; links: { name: string; url: string }[] };
    }
  | {
      type: ActionTypes.UPDATE_OUTPUTS;
      payload: { outputId: string; text: string };
    };

export function publishedFormReducer(
  state: PublishedFormState,
  action: IActionType,
): PublishedFormState {
  switch (action.type) {
    case ActionTypes.CREATE_VARIABLES_INPUTS:
      return {
        ...state,
        variablesInputs: [
          ...state.variablesInputs,
          action.payload.variableInput,
        ],
      };

    case ActionTypes.CREATE_VARIABLES_OUTPUTS:
      return {
        ...state,
        variablesOutputs: [
          ...state.variablesOutputs,
          action.payload.variableOutput,
        ],
      };

    case ActionTypes.CLEAR_VARIABLES_INPUTS:
      return {
        ...state,
        variablesInputs: [],
      };

    case ActionTypes.CLEAR_VARIABLES_OUTPUTS:
      return {
        ...state,
        variablesOutputs: [],
      };

    case ActionTypes.UPDATE_INPUT_TEXT:
      return {
        ...state,
        variablesInputs: state.variablesInputs.map(item =>
          item.inputId === action.payload.inputId
            ? { ...item, inputText: action.payload.inputText }
            : item,
        ),
      };

    case ActionTypes.UPDATE_INPUT_LINKS:
      return {
        ...state,
        variablesInputs: state.variablesInputs.map(item =>
          item.inputId === action.payload.inputId
            ? { ...item, links: action.payload.links }
            : item,
        ),
      };

    case ActionTypes.UPDATE_OUTPUTS:
      return {
        ...state,
        variablesOutputs: state.variablesOutputs.map(item =>
          item.outputId === action.payload.outputId
            ? { ...item, text: action.payload.text }
            : item,
        ),
      };

    default:
      return state;
  }
}
